'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const clsx = require('clsx');
const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const clsx__default = /*#__PURE__*/_interopDefault(clsx);
const React__default = /*#__PURE__*/_interopDefault(React);

const layoutWrapper = "_layout-wrapper_1tfim_1";
const styles = {
	layoutWrapper: layoutWrapper
};

const PageLayout = ({ children, className, style }) => {
  return React__default.default.createElement("div", { className: clsx__default.default(styles.layoutWrapper, className), "data-zds": true, style }, children);
};

exports.PageLayout = PageLayout;
//# sourceMappingURL=PageLayout.cjs.js.map
